"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccountTransaction = exports.createAccountInstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
// import { getGmIDL } from '..';
const marketplace_1 = require("../marketplace");
/**
 * Creates an instruction to initialize an order account which can be passed into an initialize order instruction.
 *
 * Must add to an existing web3.Transaction. Transaction recentBlockhash and feePayer must be defined.
 * Must call '.partialsign(orderAccount)' before sending transaction containing this instruction or you will receive signature verification errors.
 *
 * @param connection
 * @param payer - PublicKey of order initializer
 * @param orderAccount - Keypair for order account, can be obtained with 'anchor.web3.Keypair.generate()'
 * @param programId - Deployed program ID for GM program
 */
function createAccountInstruction(connection, payer, orderAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = (0, marketplace_1.getGmIDL)(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        return web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer,
            newAccountPubkey: orderAccount.publicKey,
            space: program.account.orderAccount.size,
            lamports: yield connection.getMinimumBalanceForRentExemption(program.account.orderAccount.size),
            programId,
        });
    });
}
exports.createAccountInstruction = createAccountInstruction;
/**
 * Creates a transaction to initialize an order account which can be passed into an initialize order instruction.
 *
 * Can '.add()' additional instructions to this transaction.
 *
 * Must call '.partialsign(orderAccount)' before sending this transaction or you will receive signature verification errors.
 *
 * @param connection
 * @param payer - Public key of order initializer
 * @param orderAccount - Keypair for order account, can be obtained with 'anchor.web3.Keypair.generate()'
 * @param programId - Deployed program ID for GM program
 */
function createAccountTransaction(connection, payer, orderAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = (0, marketplace_1.getGmIDL)(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const tx = new web3_js_1.Transaction({
            recentBlockhash: (yield connection.getLatestBlockhash()).blockhash,
            feePayer: payer,
        });
        tx.add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer,
            newAccountPubkey: orderAccount.publicKey,
            space: program.account.orderAccount.size,
            lamports: yield connection.getMinimumBalanceForRentExemption(program.account.orderAccount.size),
            programId,
        }));
        return tx;
    });
}
exports.createAccountTransaction = createAccountTransaction;
//# sourceMappingURL=gmHelper.js.map